var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0391 0.5H2.95312C1.32031 0.5 0 1.78906 0 3.38281V37.6094C0 39.2031 1.32031 40.5 2.95312 40.5H37.0391C38.6719 40.5 40 39.2031 40 37.6172V3.38281C40 1.78906 38.6719 0.5 37.0391 0.5ZM11.8672 34.5859H5.92969V15.4922H11.8672V34.5859ZM8.89844 12.8906C6.99219 12.8906 5.45312 11.3516 5.45312 9.45312C5.45312 7.55469 6.99219 6.01562 8.89844 6.01562C10.7969 6.01562 12.3359 7.55469 12.3359 9.45312C12.3359 11.3438 10.7969 12.8906 8.89844 12.8906ZM34.0859 34.5859H28.1562V25.3047C28.1562 23.0938 28.1172 20.2422 25.0703 20.2422C21.9844 20.2422 21.5156 22.6562 21.5156 25.1484V34.5859H15.5938V15.4922H21.2812V18.1016H21.3594C22.1484 16.6016 24.0859 15.0156 26.9688 15.0156C32.9766 15.0156 34.0859 18.9688 34.0859 24.1094V34.5859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c13894aa3387c081d1d04196d93acd93.svg";
export { ForwardRef as ReactComponent };